/* eslint-disable @typescript-eslint/no-explicit-any */

// request.tsx
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddDCConnection {
	subId: string;
	datacenterIdSource: string;
	hardwareIdSource: number|null;
	portIdSource: number|null;
	capacityMbps: number;
	connectionType: string;
	datacenterIdDest?: string | number;
	datacenterSource?: string | null;
	hardwareIdDest?: number|null;
	portIdDest?: number|null;
  id?:number;
	metadata?: object;
}

//GET /v1/resource-manager/datacenters
export function getAllDatacenters(token: string, includeHardware?: boolean){
	const params = includeHardware ? { includeHardware: 'true' } : {};
	return axios.get(`${API_URL}/v1/resource-manager/datacenters`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params,
	});	
}

//GET v1/dataCentersConnection/:id
export function getDatacenterById(token: string, datacenterId: string){
	const encodedId = encodeURIComponent(datacenterId);
	return axios.get(`${API_URL}/v1/resource-manager/datacenters/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//POST v1/resource-manager/datacenters
export function createDatacenter(token: string, payload: Partial<any>){
	return axios.post(`${API_URL}/v1/resource-manager/datacenters`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});	
}


//PUT v1/dataCentersConnection/:id
export function updateDatacenter(token: string, datacenterId: string, payload: Partial<any>){
	const encodedId = encodeURIComponent(datacenterId);
	return axios.put(`${API_URL}/v1/resource-manager/datacenters/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});	
}

//DELETE v1/resource-manager/datacenters/:datacenterId
export function deleteDatacenter(token: string, datacenterId: string){
	const encodedId = encodeURIComponent(datacenterId);
	return axios.delete(`${API_URL}/v1/resource-manager/datacenters/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

//GET providers list for the create data center modal
export function getProviders(token: string){
	return axios.get(`${API_URL}/v1/resource-manager/providers`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});	
}

